import React, { useState } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { DropzoneArea } from 'material-ui-dropzone';
import { useSnackbar } from 'notistack';

export default function DropzoneModal({ uploadAttachment, setUploadAttachment, onClose, onUploadAttachment, isLoading, count }) {
    const { enqueueSnackbar } = useSnackbar();
    const [files, setFiles] = useState([]); 
    const [dropzoneKey, setDropzoneKey] = useState(0); 
    const [totalFileCount, setTotalFileCount] = useState(0);
    const onDropFiles = (newFiles) => {
        const existingFiles = files || [];
        const validFiles = [];
        let hasDuplicate = false;
        newFiles.forEach((file) => {
            if (existingFiles.some((existingFile) => existingFile.name === file.name && existingFile.size === file.size)) {
                hasDuplicate = true;
                enqueueSnackbar(`Duplicate file detected: ${file.name}`, {
                    variant: 'error',
                    anchorOrigin: { horizontal: 'right', vertical: 'top' },
                });
            } else {
                validFiles.push(file);
            }
        });
        if (hasDuplicate) {
            setDropzoneKey((prevKey) => prevKey + 1);
        }
        if (validFiles.length > 0) {
            let updatedFiles = [...existingFiles, ...validFiles];
            if(10-count <updatedFiles.length){
                setDropzoneKey((prevKey) => prevKey + 1);
                setFiles([...existingFiles]);
                setUploadAttachment({ ...uploadAttachment, files: existingFiles });
                setTotalFileCount(existingFiles.length +count);    
                enqueueSnackbar(`You can upload remaining files which is ${10 - (count||0)} , as ${count ||0} files are already uploaded previously`, {variant: 'error',anchorOrigin: { horizontal: 'right', vertical: 'top' },});
            }
            else{
                // const updatedFiles = [...existingFiles, ...validFiles];
                const filelength = (updatedFiles.length + count)
                setFiles(updatedFiles); 
                setUploadAttachment({ ...uploadAttachment, files: updatedFiles });
                setTotalFileCount(filelength);        }
            }
    };
    const onDeleteFile = (deletedFile) => {
        const updatedFiles = files.filter(
            (file) => !(file.name === deletedFile.name && file.size === deletedFile.size)
        );
        setFiles(updatedFiles);
        setUploadAttachment({ ...uploadAttachment, files: updatedFiles });
    };
    
    return (
        <div>
            <Dialog
                open={uploadAttachment?.modal}
                onClose={onClose}
                className='project-management-modal' 
                fullWidth 
                aria-labelledby="scroll-dialog-title" 
            >
                <DialogTitle id="scroll-dialog-title">
                    Upload Attachment(s)
                </DialogTitle>
                <DialogContent dividers={true}>
                    <div>
                        <DropzoneArea
                            key={dropzoneKey} 
                            filesLimit={10-count}
                            maxFileSize={131072000}
                            showPreviewsInDropzone={false}
                            useChipsForPreview={true}
                            showPreviews={true}
                            dropzoneText={<p>Drag & Drop Documents<br /> OR <br /> Click Here<br /> </p>}
                            dropzoneClass="drag-drop-cnt"
                            maxWidth="sm"
                            showAlerts={[]} 
                            alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                            clearOnUnmount={false} 
                            initialFiles={files} 
                            getFileLimitExceedMessage={() =>  enqueueSnackbar(count>0?`You can upload remaining files which is ${10 - count} , as ${count} files are already uploaded previously`:`You can upload Only 10 Files`, {variant: 'error',anchorOrigin: { horizontal: 'right', vertical: 'top' },})}
                            onDrop={(newFiles) => onDropFiles(newFiles)}
                            onDelete={onDeleteFile}
                        />
                        <p><span style={{background:'#ffe160', fontSize:'11px', padding:'2px 3px'}}>Max 10 files can be Uploaded </span><br/><span style={{fontSize:'11px', padding:'2px 3px'}}>Remaining:{10-count} File(s).</span></p>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button disabled={isLoading} onClick={onClose} color="primary" variant='outlined' size='small'>Cancel</Button>
                    <Button disabled={isLoading||!files.length} onClick={()=>onUploadAttachment(totalFileCount,totalFileCount-10, count)} color="primary" variant='contained' size='small'>
                        {isLoading ? <CircularProgress size={20} /> : 'Upload'}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}